const access = {
  'Master Distributor Management': {
      "Listing Master Distributor": "MDM1",
      "View Specific Master Distributor Details": "MDM2",
      "Flagging Master Distributor Transactions": "MDM3",
      "Add Master Distributor": "MDM4",
      "Edit Master Distributor": "MDM5",
      "Activate / Deactivate Master Distributor": "MDM6",
      "Master Distributor Transactions": "MDM7"
  },
  'Sub Distributor Management': {
      "Listing Sub Distributor": "SDM1",
      "Activate / Deactivate Sub Distributor": "SDM2",
      "Flagging Sub Distributor Transactions": "SDM3",
      "Add Sub Distributor": "SDM4",
      "Edit Sub Distributor": "SDM5",
      "View Specific Sub Distributor Details": "SDM6",
      "Sub Distributor Transactions": "SDM7"
  },
  'Distributor Management': {
      "Listing Distributor": "DM1",
      "Edit Distributor": "DM2",
      "Flagging Distributor Transactions": "DM3",
      "Add Distributor": "DM4",
      "Activate / Deactivate Distributor": "DM5",
      "View Specific Distributor Details": "DM6",
      "Distributor Transactions": "DM7"
  },
  'Agent Management': {
      "Listing Agent": "AM1",
      "Edit Agent": "AM2",
      "Flagging Agent Transactions": "AM3",
      "Add Agent": "AM4",
      "Activate / Deactivate Agent": "AM5",
      "View Specific Agent Details": "AM6",
      "Agent Transactions": "AM7"
  },
  'Retailer Management': {
      "Listing Retailers": "RM1",
      "Edit Retailer": "RM2",
      "Flagging Retailer Transactions": "RM3",
      "Add Retailer": "RM4",
      "Activate / Deactivate Retailer": "RM5",
      "View Specific Retailer": "RM6",
      "Retailer Transactions": "RM7"
  },
  'Customer Management': {
      "Listing Customer": "CM1",
      "Edit Customer": "CM2",
      "Flagging Customer Transactions": "CM3",
      "Add Customer": "CM4",
      "Activate / Deactivate Customer": "CM5",
      "View Specific Customer Details": "CM6",
      "Customer Transactions": "CM7"
  },
  'Reversal Request': {
      "Listing Reversal Request": "RR1",
      "View Specific Reversal Request Details": "RR2",
      "Approve / Reject Reversal Request": "RR3"
  },
  'Services': {
      "Do Mobile Recharge": "S1",
      "Bundle / Package Activation": "S2",
      "Breshna Service Utilization": "S3"
  },
  'Company Management': {
      "Listing Company": "CMGT1",
      "Add Company": "CMGT4",
      "Edit Company": "CMGT3",
      "View Specific Company Details": "CMGT2",
  },
  'MNO Management': {
      "Listing MNO": "MM1",
      "Edit MNO": "MM2",
      "Add Service Fee": "MM3",
      "Add MNO": "MM4",
      "Add Purchase Amount": "MM5",
      "View Specific MNO Details": "MM6"
  },
  'Support Ticket': {
      "Listing Support Ticket": "ST1",
      "View Specific Support Ticket Details": "ST2",
      "Take Action on Support Ticket": "ST3"
  },
  'Onboarding Request': {
      "Listing All Onboarding Request": "OR1",
      "Edit the Onboarding Request": "OR2",
      "Approve / Reject the Onboarding Request": "OR3",
      "View Specific Onboarding Request Details": "OR4"
  },
  'Modification Request': {
      "Listing All Modification Request": "MR1",
      "Edit the Modification Request": "MR2",
      "Approve / Reject the Modification Request": "MR3",
      "View Specific Modification Request Details": "MR4"
  }, 
  'Dashboard': {
      "Total Number of Users on the Platform": "D1",
      "Geographical MNO Recharge Sales": "D2",
      "Customer MNO Recharge Sales": "D3",
      "Total Number of Receivables": "D4",
      "Geographical MNO Package Activation Sales": "D5",
      "MNO Available Balance": "D6",
      "Total Number of Payables": "D7",
      "Geographical ETop Up Stock Sales": "D8",
      "MNO Wise Recharge Sales Trend": "D9",
      "Recharge Report": "D10",
      "Merchant Wise MNO Recharge Sales": "D11",
      "MNO Target Vs Achievement": "D12",
      "MNO Wise Package Sales Trend": "D13",
      "Average Recharge Sales Report": "D14",
      "ETop Up Stock Sales Trend": "D15",
      "Merchant Wise MNO Package Activation Sales": "D16",
      "Payables For MNO": "D17",
      "Merchant Wise ETop Up Stock Sales": "D18",
      "Receivables from MNO": "D19",
      "Top 3 Merchant Wise ETop Up Stock Transfer Ranking": "D20",
      "Top 10 Merchant Wise Recharge Sales Ranking": "D21",
  },
  'CVM Dashboard': {
      "Active / Inactive / Dormant Users Status": "CVM1",
      "Top 3 Merchantwise ETop Up Stock Transfer Ranking": "CVM2",
      "System Transactional Performance Ratio": "CVM3",
      "Target vs Achievement": "CVM4",
      "Count of Users": "CVM5"
  },
  'Reports': {
      "ETop Up Recharge Report": "R1",
      "MNO Wise Bundle Balance Activation Report": "R2",
      "CVM Report": "R3",
      "Bundle Activation Report": "R4",
      "MNO Wise ETop Up Purchase Report": "R5",
      "On Target Achievement of MNO Report": "R6",
      "Unsuccessful Transaction Report": "R7",
      "MNO Wise Bundle Balance Purchase Report": "R8",
      "Geographical Sales Report": "R9",
      "MNO's Service Fee Earned Report": "R10",
      "Merchant / Customer eTop Up Wallet Balance Report": "R11",
      "Stock Account Statement": "R12",
      "MNO Wise Sales Trend Report": "R13",
      "ZoodPay Profitability Report": "R14",
      "Money Accounts Statement": "R15",
      "Stock Transfer Report": "R16",
      "Recharge Reversal Report": "R17",
      "Upfront Purchased Report": "R18",
      "Wallet Transfer Report": "R19",
      "ETop Up Stock / Digital Wallet Report of Admin / Super Admin": "R20",
      "Upfront Sales Report": "R21",
      "MNO Wise ETop Up Available Balance Report": "R22",
      "ETop Up Stock Reversal Report": "R23"
  },
  'Bulk Amount Transfer': {
      "Capability to do Bulk Recharge": "BAT1",
      "Wallet / Fund Transfer": "BAT2",
      "Capability to do Bulk Bundle Activation": "BAT3"
  },
  'Career Section Management': {
      "Add Data Related to Career": "CSM1",
      "Remove Data Related to Career": "CSM2",
      "View all Job Application": "CSM3"
  },
  'Blog Management': {
      "Add Blog": "BM1",
      "Remove Blog": "BM2",
      "View the Blog": "BM3"
  }
};

// Utility function to get total count of privileges
export const getTotalPrivilegesCount = (): number => {
  let totalCount = 0;
  Object.values(access).forEach(section => {
    totalCount += Object.keys(section).length;
  });
  return totalCount;
};

// Export the access object
export { access };